export const setLocal = (key, value) => {
  localStorage.setItem(key, value);
};
export const getLocal = (key) => localStorage.getItem(key);

export const clearLocal = () => {
  localStorage.clear();
};
